//View for a single span of a card
//Iterated through and several views are rendered to make up the parent view

define('views/linkedaccounts/linkedcard',[
	"backbone",
	"views/_base/baseview",
	"text!views/linkedaccounts/linkedcard.html",
	"views/linkedaccounts/edit",
	"views/shared/modal/modal_modern",
	"views/shared/alerts/alert",
], function (Backbone, BaseView, Template, EditView, Modal, AlertModalView) {
	"use strict";

	return BaseView.extend({
		className: "linked-card-container",
		tagName: "li",
		isRender: true,
		template: _.template(Template),
		events: {
			"click .js-edit-linked-account": "editAccount",
			"click .js-linked-accounts-card-action": "editAccount",
			"click .js-linked-accounts-card-action-delete": "deleteCard",
		},
		initialize: function (options) {
			options = options || {};

			this.data = options.data;
			this.card_view = options.card_view;
			this.card_id = options.card_id;

			this.edit_view = null;
			this.is_open = false;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			this.$el.html(this.template());

			return this;
		},

		loadData: function () {
			this.renderCard();
		},

		renderCard: function () {
			//function renders cards listed in the linked accounts page on load
			var card_last_4 = this.data.Identifier,
				card_type = this.data.NetworkSourceID,
				name_separator = " - ",
				card_name = this.data.NickName === card_last_4 ? "" : this.data.NickName;

			//For the default PayForward Debit Account
			if (this.data.CardTypeID == enums.cardTypes.GPRDebitCard) {
				card_name = "PayForward Account";
				card_last_4 = "";
				name_separator = "";
			}

			//For externally linked accounts
			//Only override card names if they don't have nicknames
			if (card_type === enums.networkSources.Visa && card_name === "") {
				card_name = "Visa";
			} else if (card_type === enums.networkSources.MasterCard && card_name === "") {
				card_name = "MasterCard";
			}

			var cardNameHTML =
				'<span class="linked-accounts-card-name js-linked-accounts-card-name">' +
				card_name +
				name_separator +
				card_last_4 +
				"</span>";
			var cardIconsHTML = this.generateAdditionalIcons();

			var cardHTML = cardNameHTML + cardIconsHTML;
			this.$(".js-edit-linked-account").append(cardHTML);
		},

		generateAdditionalIcons: function () {
			//function is to help decide what icons and options to display in the Linked Card div
			var is_default = this.data.IsDefault,
				is_expired = this.data.IsExpired,
				expirationMonth = this.data.ExpirationMonth,
				expirationYear = this.data.ExpirationYear;

			var expirationHTML = "";

			var editIconHTML =
				'<span class="linked-accounts-card-action js-linked-accounts-card-action">' +
				enums.svg.editIcon +
				"</span>";

			var deleteIconHTML =
				'<span class="linked-accounts-card-action linked-accounts-card-action-delete js-linked-accounts-card-action-delete">' +
				enums.svg.trashIcon +
				"</span>";

			var defaultCardIconHTML =
				'<span class="linked-accounts-card-default js-linked-accounts-card-default">' +
				enums.svg.checkIcon +
				"Default</span>";

			//Payforward Account Option
			if (this.data.CardTypeID === enums.cardTypes.GPRDebitCard) {
				deleteIconHTML = "";
			}

			//Default Account Options
			if (!is_default) {
				defaultCardIconHTML = "";
			}

			//Expired Card Options
			//If it's expired, show expiration date and hide edit + default
			if (is_expired) {
				expirationHTML =
					'<span class="linked-accounts-card-default js-linked-accounts-card-default expired"> Expired ' +
					expirationMonth +
					"/" +
					expirationYear +
					"<span>";
				deleteIconHTML =
					'<span class="linked-accounts-card-action linked-accounts-card-action-delete js-linked-accounts-card-action-delete expired">' +
					enums.svg.trashIcon +
					"</span>";
				defaultCardIconHTML = "";
				editIconHTML = "";
			}

			var generatedHTML = deleteIconHTML + editIconHTML + expirationHTML + defaultCardIconHTML;

			return generatedHTML;
		},

		editAccount: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			this.card_view.closeAllCardForms(this.data.LinkedCardGUID);

			if (this.edit_view) {
				this.edit_view.$el.toggle();
			} else {
				this.edit_view = new EditView({ card: this.data, card_view: this });
				this.$el.find(".js-linked-accounts-card-edit-form-container").html(this.edit_view.el).show();
			}

			this.toggleEditIcon();
		},

		clearInput: function () {
			this.$el.find(".js-linkedcard-name").val("");
		},

		toggleEditIcon: function () {
			this.$el.find(".js-linked-accounts-card-action").toggle();
			this.$el.find(".js-linked-accounts-card-action-delete").toggle();

			if (this.is_open) {
				this.is_open = false;
				this.clearInput();
			} else {
				this.is_open = true;
			}
		},

		toggleEditForm: function (is_modal) {
			if (is_modal) {
				return this.alert_modal_view.$el.toggle();
			}

			return this.edit_view.$el.toggle();
		},

		closeEditForm: function (updates) {
			this.card_view.closeAllCardForms(this.data.LinkedCardGUID);

			this.toggleEditIcon();
			this.toggleEditForm(updates.isModal);

			if (updates.render) {
				$(".js-linked-accounts-cards").html("");
				this.card_view.getLinkedCards();
			}
		},

		deleteCard: function () {
			var that = this;

			checkFinRegStatus(function (resp) {
				if (resp === true) {
					var title = "Unlink Card",
						body =
							"Are you sure you want to unlink your card? You will cease to receive rebates for this card once you unlink it.";

					if (that.data.IsExpired) {
						title = "Remove Card";
						body = "Do you want to delete this expired card?";
					}

					that.alert_modal_view = new AlertModalView({
						// General
						calling_view: that,
						alert_type: 2,
						// Transactional
						is_transaction: false,
						// Content
						alert_header: title,
						alert_message: body,
						alert_message_icon: enums.svg.trashCircleIcon,
						// Default
						btn_label: "Delete",
						btn_color: "blue",
						btn_callback: that.unlinkCardMODAL,
						btn_retry_callback: that.unlinkCardMODAL,

						// Confirm
						btn_confirm: false,
						// Success
						btn_success: true,
						btn_success_delay: 700,
						btn_success_label: "OK",
						btn_success_message: "Card successfully unlinked",
						btn_success_callback: that.unlinkCardSuccess,
						// Error
						btn_error: true,
						btn_error_delay: 700,
						btn_error_label: "Retry",
						btn_error_cancel_label: "Cancel",
						btn_error_message: "Error when unlinking card. Please try again.",
						btn_error_callback: that.canceledUnlinkCardOnError,
					});

					that.alert_modal = new Modal({
						show: true,
						content: that.alert_modal_view.$el.html(),
						calling_view: that.alert_modal_view,
					});
				}
			});

			return false;
		},

		unlinkCardMODAL: function (processComplete, that) {
			var that = that ? that : this,
				data = { guid: that.data.LinkedCardGUID };

			$.ajax({
				type: "POST",
				url: pf.consumerURL + "/RemoveLinkedCard",
				async: false,
				data: JSON.stringify(data),
				contentType: "application/json",
				success: function (response) {
					if (response) {
						if (processComplete.name) {
							that.alert_modal_view[processComplete.name](true);
						} else {
							processComplete(true, that.alert_modal_view);
						}
					} else {
						if (processComplete.name) {
							that.alert_modal_view[processComplete.name](false);
						} else {
							processComplete(false, that.alert_modal_view);
						}
					}
				},
				error: function (response) {
					if (processComplete.name) {
						that.alert_modal_view[processComplete.name](false);
					} else {
						processComplete(false, that.alert_modal_view);
					}
				},
			});
		},

		cancelUnlinkCard: function (that) {
			var that = that ? that : this;

			that.alert_modal.$el.fadeOut(function () {
				that.alert_modal.$el.remove();
			});
		},

		unlinkCardSuccess: function (resetButtons, that) {
			var that = that ? that : this;
			that.closeEditForm({ render: true, isModal: true });
		},

		canceledUnlinkCardOnError: function (that) {
			// console.log('canceledUnlinkCardOnError');
		},

		close: function () {},
	});
});

